import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { useTrackScreenOpened, TRACKING_EVENTS } from '@services/tracking';
import { Machine } from '@interfaces/machines';

export const useTrackMachineScheduledOpened = () => {
  const selectedItem = useSelector(selectSelectedItem) as Machine;

  useTrackScreenOpened(TRACKING_EVENTS.MACHINE_SCHEDULED, () => ({
    machineId: selectedItem?.machineId ? String(selectedItem.machineId) : undefined,
    machineName: selectedItem?.shortName || selectedItem?.fullName || undefined,
  }));
};
